import { TGetAccessTokenResponseDto } from '~/app-modules/auth/clients/dto/get-access-token-response-dto';
import { NotLoggedIn } from '~/app-modules/core/errors/not-logged-in';

export interface ITokensPair {
  accessToken: string;
  refreshToken: string;
  updated: Date;
}

@singleton()
export class TokensStore {
  constructor() {
    this._tokens = useCookie('backoffice-auth', { default: () => null });
  }

  protected _tokens: Ref<ITokensPair | null>;

  setTokens(tokensPair: TGetAccessTokenResponseDto) {
    this.dropTokens();
    this._tokens.value = {
      accessToken: tokensPair.accessToken,
      refreshToken: tokensPair.refreshToken,
      updated: new Date(),
    };
  }

  get tokens(): ITokensPair | null {
    return this._tokens.value;
  }

  dropTokens() {
    this._tokens.value = null;
  }

  get accessToken(): string {
    if (!this._tokens.value?.accessToken) throw new NotLoggedIn();

    return `Bearer ${this._tokens.value.accessToken}`;
  }

  get refreshToken(): string {
    if (!this._tokens.value?.refreshToken) throw new NotLoggedIn();

    return this._tokens.value.refreshToken;
  }
}
